import { createLevelUpTaskApi, getLevelUpTasksApi, updateLevelUpTaskApi } from 'api/levelUpTask';
import { ActionItem } from 'models/actionItem';

export const createLevelUpTask = ({
  checkInInstanceId,
  competencyId,
  levelUpId,
  status,
  uiKey,
  dueTS,
  text,
  toIds,
  teams,
  label,
  employeeId,
}) =>
  createLevelUpTaskApi({
    checkInInstanceId,
    competencyId,
    levelUpId,
    status,
    uiKey,
    dueTS,
    text,
    toIds,
    teams,
    label,
    employeeId,
  }).then((res) => ActionItem.fromJSON(res.entity));

export const updateLevelUpTask = ({
  checkInInstanceId,
  status,
  uiKey,
  dueTS,
  text,
  toIds,
  teams,
  label,
  uuid,
  employeeId,
}) =>
  updateLevelUpTaskApi({
    checkInInstanceId,
    status,
    uiKey,
    dueTS,
    text,
    toIds,
    teams,
    label,
    uuid,
    employeeId,
  }).then((res) => ActionItem.fromJSON(res.entity));

export const getLevelUpTasks = ({ competencyId, levelUpId, limit, offset, employeeId }) =>
  getLevelUpTasksApi({
    competencyId,
    levelUpId,
    limit,
    offset,
    employeeId,
  }).then((res) => res.entity.map((actionItem) => ActionItem.fromJSON(actionItem)));
